import src from "IMAGE";
export default { src, width: 528, height: 640, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAANUlEQVR42pWPwQkAIAwDu/+AGSAka1hR8CMi7eMI5B4hIWnYzpvVx0scapJkAtjZk/3N35UJHHzNg5y9IzcAAAAASUVORK5CYII="};
